import { containerless, bindable, bindingMode, customElement } from 'aurelia-framework';
import { inject, Parent } from 'aurelia-dependency-injection';
import { BootstrapNavItem } from './fs-nav-item';

@inject(Element, Parent.of(BootstrapNavItem))
@containerless
@customElement('fs-nav-item-body')

export class BootstrapNavItemBody {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public class: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public style: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public href: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public title: string;

    @bindable({ defaultBindingMode: bindingMode.oneTime }) public active: boolean | string = false;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public disabled: boolean | string = false;

    private isFade: boolean = false;

    public parent: any;

    public element: Element;

    public tab_body: any;

    constructor(element: Element, parent) {
        this.parent = parent;
        this.element = element;
    }

    bind(bindingContext: any, overrideContext: any) {
        this.active = this.parent.active;
        this.disabled = this.parent.disabled;

        let navs: HTMLElement;
        navs = this.tab_body.parentElement;

        let tab_content: HTMLElement;
        tab_content = <HTMLElement>navs.parentElement.parentElement.children.item(1).children.item(0);

        let tab_body_id = `${this.parent.id}-tab-body`;
        navs.removeChild(this.tab_body);

        if (this.tab_body.textContent.length > 8) {

            this.tab_body.setAttribute('id', `${tab_body_id}`);
            this.tab_body.setAttribute('aria-labelledby', `${this.parent.id}`);

            tab_content.appendChild(this.tab_body);
        }

    }
}